module.exports = __webpack_public_path__ + "img/type--1-spans--single-lang--pt.bd89071b.jpg";